var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.75098 11C5.78353 11 5.81527 10.994 5.84619 10.982C5.87712 10.97 5.90397 10.9503 5.92676 10.9229C5.97559 10.8715 6 10.8099 6 10.7379C6 10.666 5.97559 10.6043 5.92676 10.5529L1.60547 6L5.92676 1.45221C5.97559 1.40082 6 1.3383 6 1.26465C6 1.19099 5.97559 1.12847 5.92676 1.07708C5.87793 1.02569 5.81934 1 5.75098 1C5.68262 1 5.62402 1.02569 5.5752 1.07708L1.07324 5.81501C1.02441 5.86639 1 5.92806 1 6C1 6.07194 1.02441 6.13361 1.07324 6.18499L5.5752 10.9229C5.59798 10.9503 5.62484 10.97 5.65576 10.982C5.68669 10.994 5.71842 11 5.75098 11Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron-left.21507e2025b77d3cd3e8398df5e4ffe2.svg";
export { ForwardRef as ReactComponent };